import { format, isAfter, parseISO, subDays } from "date-fns";

/**
 * Calculates a date range for the last 30 days based on the most recent game or practice date.
 * @param gameStartDate - The start date of the game in ISO format (YYYY-MM-DD)
 * @param practiceStartDate - The start date of the practice in ISO format (YYYY-MM-DD)
 * @returns An object containing startDate (30 days before the latest date) and endDate (the latest date), or null if no valid dates are provided
 */
export const calculateLastThirtyDaysDateRange = (
  gameStartDate: string | null,
  practiceStartDate: string | null,
) => {
  // If both are null, return null as there is no data to show
  if (!gameStartDate && !practiceStartDate) {
    return null;
  }

  const latestPlayedDate =
    gameStartDate && practiceStartDate
      ? isAfter(parseISO(gameStartDate), parseISO(practiceStartDate))
        ? gameStartDate
        : practiceStartDate
      : (gameStartDate ?? practiceStartDate);

  return latestPlayedDate
    ? {
        startDate: format(
          subDays(parseISO(latestPlayedDate!), 30),
          "yyyy-MM-dd",
        ),
        endDate: format(parseISO(latestPlayedDate!), "yyyy-MM-dd"),
      }
    : null;
};
